import React from 'react'
import InputMoment from 'input-moment'
import styled from 'styled-components'

export default class DateTimePicker extends React.Component {
  handleValueChange = prevMoment => {
    this.setState({
      value: prevMoment,
    })
  }

  handleSave = () => {
    if (this.props.onSave) {
      this.props.onSave(this.state.value)
    }
  }

  getValue = () => this.props.value

  render() {
    return (
      <CalendarModalBodyLayout>
        <InputMoment
          minStep={5}
          onChange={this.handleValueChange}
          moment={this.props.value}
          onSave={this.handleSave}
        />
      </CalendarModalBodyLayout>
    )
  }
}

const CalendarModalBodyLayout = styled.div`
  pointer-events: auto;
  margin: auto;
  background-color: whitesmoke;
  border-radius: 3px;
`



// WEBPACK FOOTER //
// ./src/modules/calendar/DateTimePicker.js